// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import util from './assets/js/utils'
import axios from 'axios'
Vue.config.productionTip = false

Vue.prototype.util = util // 常用工具类
Vue.prototype.$http = axios.create({
  timeout: 10000,
  // baseURL: 'https://test-qyjh.shengaitcm.com/api'
   baseURL: 'https://qyjh.sazyg.com/api'
})
Vue.prototype.local = window.localStorage // 获取本地缓存
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js